module.exports = __webpack_public_path__ + "static/029-da190c7987b2d04e3ea2e9fa3a4355e2.jpg";